import React from 'react';
import classes from './GarageContent.module.scss';

const DAY_MS = 24 * 60 * 60 * 1000;

// Whole calendar days from `value` to today, in the member's own timezone.
const daysSince = (value) => {
    const then = new Date(value);
    if (Number.isNaN(then.getTime())) return null;
    const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    return Math.max(0, Math.round((startOf(new Date()) - startOf(then)) / DAY_MS));
};

/**
 * The muted "we're waiting on the dealer in Japan" row on an inquiry or
 * inspection. The note is the API's own wording (`waitingOnDealerNote`); only
 * how long ago we asked is added here.
 */
const DealerWaitNote = ({ record }) => {
    if (!record || !record.waitingOnDealerSince || !record.waitingOnDealerNote) return null;
    const days = daysSince(record.waitingOnDealerSince);
    let asked = '';
    if (days === 0) asked = 'Asked today';
    else if (days !== null) asked = `Asked ${days} day${days === 1 ? '' : 's'} ago`;

    return (
        <p className={classes.waitNote}>
            <i className="fas fa-hourglass-half" aria-hidden="true"></i>
            <span>
                {record.waitingOnDealerNote}
                {asked && <span className={classes.waitAge}>{asked}</span>}
            </span>
        </p>
    );
};

export default DealerWaitNote;
